<template>
  <div class="fts-identity-display">
    <!-- member -->
    <fts-profile
      :user-name="identityUsername"
      :user-list="users"
      :profile-photo-size="profilePhotoSize"
      profile-name-class="identity-display identity-display--profile"
      v-if="identityType === 'user'"
    >
      <template #profileName="{ userProfileUsername, userProfileName }">
        <div class="identity-display-name">{{userProfileName || identityName}}</div>
        <div class="identity-display-tag">{{userProfileUsername}}</div>
        <div class="identity-display-badge">User</div>
      </template>
    </fts-profile>
    <!-- module -->
    <div
      class="identity-display"
      v-else-if="identityType === 'profile'"
    >
      <fts-moji
        :emoji="getModuleEmoji"
        :size="emojiSize"
        class="identity-display-emoji"
        v-if="getModuleEmoji"
      />
      <div class="identity-display-name">{{getModuleName}}</div>
      <div class="identity-display-badge">Profile</div>
    </div>
    <!-- listing -->
    <div
      class="identity-display"
      v-else-if="identityType === 'listing'"
    >
      <fts-moji
        :emoji="getListingInfo.listingEmoji"
        :size="emojiSize"
        class="identity-display-emoji"
        v-if="getListingInfo.listingEmoji"
      />
      <div class="identity-display-name">{{getListingInfo.listingName}}</div>
      <div
        class="identity-display-badge identity-display-badge--module"
        v-if="getListingInfo.moduleName"
      >
        <fts-moji
          :emoji="getListingInfo.moduleEmoji"
          :size="14"
          class="identity-display-badge--module-emoji"
          v-if="getListingInfo.moduleEmoji"
        />
        <div class="identity-display-badge--module-name">
          {{getListingInfo.moduleName}}
        </div>
      </div>
    </div>
    <!-- workspace -->
    <div
      class="identity-display"
      v-else-if="identityType === 'workspace'"
    >
      <font-awesome-icon
        :icon="['fas', 'user-friends']"
        fixed-width
        class="identity-display-icon"
      />
      <div class="identity-display-name">{{identityName}}</div>
      <div class="identity-display-badge">Workspace</div>
    </div>
    <!-- information -->
    <div
      class="identity-display"
      v-else-if="identityType === 'information'"
    >
      <i
        :class="getInformationIcon"
        class="identity-display-icon"
        v-if="getInformationIcon"
      ></i>
      <div class="identity-display-name">{{getInformatioName}}</div>
      <div class="identity-display-badge">Information</div>
    </div>
    <!-- custom -->
    <div
      class="identity-display"
      v-else
    >
      <div class="identity-display-name">{{identityName}}</div>
      <div class="identity-display-badge">Custom</div>
    </div>
  </div>
</template>

<script>
import FTSProfile from './FTSProfile'
import FTSMoji from './FTSMoji'
import commons from '../commons/commons';

export default {
  components: {
    'fts-profile': FTSProfile,
    'fts-moji': FTSMoji
  },
  props: {
    modules: Array,
    users: Array,
    information: Array,
    identityType: String,
    identityId: [String, Number],
    identityName: String,
    identityUsername: String,
    identityEmoji: String,
    profilePhotoSize: Number,
    emojiSize: Number,
  },
  computed: {
    getListingInfo() {
      let item = { listingName: this.identityName, listingEmoji: this.identityEmoji };
      try {
        const identityId = this.identityId && this.identityId.split(':');
        const moduleId = identityId[0];
        const listingId = identityId[1];
        const findModule = Array.isArray(this.modules) && this.modules.find((x) => x.id == moduleId);
        if (findModule) {
          item.moduleName = findModule.name;
          item.moduleEmoji = findModule.emoji;
        }


      } catch(err) { console.error(err); }

      return item;
    },
    getModule() {
      if (Array.isArray(this.modules) && this.identityId) {
        return this.modules.find((x) => x.id == this.identityId);
      }
    },
    getModuleName() {
      return this.getModule && this.getModule.name ?
        this.getModule.name :
        this.identityName ?
          this.identityName : '(undefined)';
    },
    getModuleEmoji() {
      try {
        const findModule = this.modules.find((x) => x.id == this.identityId);
        return findModule && findModule.emoji;
      } catch(err) { console.error(err); }
    },
    getInformation() {
      if (Array.isArray(this.information) && this.identityId) {
        return this.information.find((x) => x.id === this.identityId);
      }
    },
    getInformationIcon() {
      if (this.getInformation) {
        if (this.getInformation.type !== null || this.getInformation.type !== undefined) {
          const icon = commons.informationIcon(this.getInformation.type);
          if (icon) {
            return this.getInformation.system ?
              `${icon} identity-display-icon--system` :
              `${icon} identity-display-icon--information`
          } 
        }
      }
      return "fts-icon-text";
    },
    getInformatioName() {
      return this.getInformation && (this.getInformation.displayName || this.getInformation.name) ?
        this.getInformation.displayName || this.getInformation.name :
        this.identityName ?
          this.identityName : '(undefined)';
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-identity-display {
  min-width: 0;
  .identity-display {
    min-width: 0;
    display: flex;
    align-items: center;
    &.identity-display--profile {
      margin-left: 0.375rem;
    }
  }
  .identity-display-emoji {
    margin-right: 0.375rem;
  }
  .identity-display-icon {
    margin-right: 0.375rem;
    color: var(--fts-default);
    &.identity-display-icon--information,
    &.identity-display-icon--system {
      color: var(--fts-text);
    }
  }
  .identity-display-name {
    @include text-overflow-ellipsis;
    font-size: $font-size;
    line-height: $line-height;
  }
  .identity-display-tag {
    @include text-overflow-ellipsis;
    flex-shrink: 2;
    min-width: 1rem;
    margin-left: 0.375rem;
    font-size: $font-size-sm;
    line-height: $line-height;
    color: var(--fts-default);
  }
  .identity-display-badge {
    @include text-overflow-ellipsis;
    min-width: 2rem;
    margin-left: 0.5rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-radius: 0.25rem;
    background-color: var(--fts-gray-200);
    color: var(--fts-gray-600);
    font-size: $font-size-sm;
    line-height: $line-height;
    &.identity-display-badge--module {
      display: flex;
      align-items: center;
      .identity-display-badge--module-emoji {
        margin-right: 0.25rem;
      }
      .identity-display-badge--module-name {
        @include text-overflow-ellipsis;
      }
    }
  }
}
</style>